import { render, staticRenderFns } from "./RecScenePicUpload.vue?vue&type=template&id=0b8ddfde&scoped=true&"
import script from "./RecScenePicUpload.vue?vue&type=script&lang=js&"
export * from "./RecScenePicUpload.vue?vue&type=script&lang=js&"
import style0 from "./RecScenePicUpload.vue?vue&type=style&index=0&id=0b8ddfde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8ddfde",
  null
  
)

export default component.exports